/// Static president data for Mensaje del Ejecutivo bills.
/// Presidents are matched by filing_date to determine who was in office.
const R2_BASE = 'https://pub-8287053583084dcebcc7f8221b6ce076.r2.dev'

export interface President {
  name: string
  slug: string
  term_start: string
  term_end: string
  term_label: string
}

const PRESIDENTS: President[] = [
  {
    name: 'Michelle Bachelet Jeria',
    slug: 'bachelet',
    term_start: '2014-03-11',
    term_end: '2018-03-10',
    term_label: '2014–2018',
  },
  {
    name: 'Sebastián Piñera Echenique',
    slug: 'pinera',
    term_start: '2018-03-11',
    term_end: '2022-03-10',
    term_label: '2018–2022',
  },
  {
    name: 'Gabriel Boric Font',
    slug: 'boric',
    term_start: '2022-03-11',
    term_end: '2026-03-10',
    term_label: '2022–2026',
  },
  {
    name: 'José Antonio Kast Rist',
    slug: 'kast',
    term_start: '2026-03-11',
    term_end: '2030-03-10',
    term_label: '2026–2030',
  },
]

/// Resolve the president in office on the given filing date.
/// Returns null if the date falls outside all known terms.
export function resolvePresident(filingDate: string): President | null {
  return PRESIDENTS.find(p => filingDate >= p.term_start && filingDate <= p.term_end) ?? null
}

/// Build the full R2 URL for a president's photo.
export function photoUrl(slug: string): string {
  return `${R2_BASE}/presidents/${slug}.webp`
}
